import React from "react";

const SocialMiner = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.44842 13.0817C7.77896 13.0817 6.4502 14.4007 6.4502 15.9978C6.4502 17.5949 7.77896 18.9139 9.44842 18.9139C11.1179 18.9139 12.4467 17.5949 12.4467 15.9978C12.4467 14.4007 11.1179 13.0817 9.44842 13.0817ZM5.2002 15.9978C5.2002 13.6835 7.11578 11.8317 9.44842 11.8317C11.7811 11.8317 13.6967 13.6835 13.6967 15.9978C13.6967 18.3121 11.7811 20.1639 9.44842 20.1639C7.11578 20.1639 5.2002 18.3121 5.2002 15.9978Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5502 14.0429L17.7828 11.8791L18.2605 13.0342L13.0279 15.198L12.5502 14.0429Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0279 16.802L18.2605 18.9658L17.7828 20.1209L12.5502 17.9571L13.0279 16.802Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2532 8.20581C19.5837 8.20581 18.255 9.52483 18.255 11.1219C18.255 12.719 19.5837 14.038 21.2532 14.038C22.9227 14.038 24.2514 12.719 24.2514 11.1219C24.2514 9.52483 22.9227 8.20581 21.2532 8.20581ZM17.005 11.1219C17.005 8.80761 18.9206 6.95581 21.2532 6.95581C23.5859 6.95581 25.5014 8.80761 25.5014 11.1219C25.5014 13.4362 23.5859 15.288 21.2532 15.288C18.9206 15.288 17.005 13.4362 17.005 11.1219Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2532 17.9622C19.5837 17.9622 18.255 19.2812 18.255 20.8783C18.255 22.4754 19.5837 23.7944 21.2532 23.7944C22.9227 23.7944 24.2514 22.4754 24.2514 20.8783C24.2514 19.2812 22.9227 17.9622 21.2532 17.9622ZM17.005 20.8783C17.005 18.564 18.9206 16.7122 21.2532 16.7122C23.5859 16.7122 25.5014 18.564 25.5014 20.8783C25.5014 23.1926 23.5859 25.0444 21.2532 25.0444C18.9206 25.0444 17.005 23.1926 17.005 20.8783Z"
      />
      <path
        d="M9.88781 14.4633C10.4228 14.6078 10.8534 15.0244 11.0144 15.5473C11.097 15.8236 11.1014 16.0872 11.0492 16.3295C10.9752 16.6653 11.0579 17.0097 11.3058 17.252L11.5624 17.5028C11.98 16.9416 12.1714 16.2147 12.0017 15.441C11.7929 14.4803 10.997 13.7066 10.0183 13.5026C9.22667 13.3368 8.48289 13.5281 7.91309 13.9319L8.16971 14.1827C8.41764 14.425 8.77431 14.5058 9.11793 14.4335C9.35716 14.3825 9.61813 14.3868 9.88781 14.459V14.4633Z"
        fill="#57CC99"
      />
      <path
        d="M21.6926 9.58731C22.2276 9.73184 22.6582 10.1484 22.8192 10.6713C22.9018 10.9476 22.9062 11.2112 22.854 11.4535C22.78 11.7893 22.8627 12.1337 23.1106 12.376L23.3672 12.6268C23.7848 12.0657 23.9762 11.3387 23.8065 10.565C23.5978 9.60431 22.8018 8.83062 21.8231 8.62657C21.0315 8.46078 20.2877 8.65208 19.7179 9.05593L19.9745 9.30674C20.2225 9.54905 20.5791 9.62982 20.9227 9.55755C21.162 9.50654 21.4229 9.51079 21.6926 9.58306V9.58731Z"
        fill="#57CC99"
      />
      <path
        d="M21.6926 19.3393C22.2276 19.4838 22.6582 19.9004 22.8192 20.4233C22.9018 20.6996 22.9062 20.9632 22.854 21.2055C22.78 21.5413 22.8627 21.8856 23.1106 22.1279L23.3672 22.3788C23.7848 21.8176 23.9762 21.0907 23.8065 20.317C23.5978 19.3563 22.8018 18.5826 21.8231 18.3785C21.0315 18.2127 20.2877 18.404 19.7179 18.8079L19.9745 19.0587C20.2225 19.301 20.5791 19.3818 20.9227 19.3095C21.162 19.2585 21.4229 19.2627 21.6926 19.335V19.3393Z"
        fill="#57CC99"
      />
    </svg>
  );
};

export default SocialMiner;
